import SanitizedHtml from './SanitizedHtml.vue';

export default SanitizedHtml;
